import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';
import { useDynamicLocale } from '@/hoslog-intl';
import * as React from 'react';
import { accountInformationRows } from '../types';
import { getColumns } from './Column';

export function AccountInformationTable() {
  const { t } = useDynamicLocale();
  const columns = React.useMemo(() => getColumns(t), [t]);
  const { table } = useDataTable({
    data: accountInformationRows,
    columns,
    pageCount: 1,
    initialState: {
      pagination: { pageIndex: 0, pageSize: 10 },
      columnVisibility: { createdDate: false },
    },
    meta: { title: t('paymentManagement.accountInformation.table.title') },
    getRowId: (row) => String(row.id),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <DataTable table={table} className="font-medium">
      <DataTableToolbar hideViewOptions />
    </DataTable>
  );
}
